import { WysiwygToolbar } from 'components/wysiwyg';

const LetterContentEditorToolbar = () => (
    <WysiwygToolbar className={`mx-auto w-full max-w-3xl !bg-transparent px-4`} />
);

export { LetterContentEditorToolbar };
